import React from "react";
import {IonButtons, IonHeader, IonMenuButton, IonTitle, IonToolbar} from "@ionic/react";

const TransactionSuccesful: React.FC = () => {
    return (
        <>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton/>
                    </IonButtons>
                    <IonTitle>Transactie bevestiging</IonTitle>
                </IonToolbar>
            </IonHeader>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}>
                <div style={{
                    padding: '20px',
                    borderRadius: '20px',
                    backgroundColor: 'white',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                    <div style={{
                        color: '#4BB543',
                        fontSize: '50px',
                    }}>
                        ✓
                    </div>
                    <h1>Transactie succesvol!</h1>
                    <p style={{
                        color: '#555',
                        fontSize: '18px',
                    }}>
                        Je saldo wordt snel bijgewerkt.
                    </p>
                </div>
            </div>
        </>
    );
};

export default TransactionSuccesful;
